import React from 'react';

export default function Rules() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: 'auto' }}>
      <h2>Game Rules: Basic</h2>
      <p><b>First, select any two video cards.</b><br />Each video card is composed of six elements.<br />Each card shares one element with every other card in its deck (and only one).</p>
      <p><b>Second, pick a prompt.</b><br />These prompts were given to an AI to render. View the cards from the lens of the AI.<br />Notice the uncanny valley separating the real world from the vision of an AI.</p>
      <p>+2 points for a correct guess<br />−1 point for a wrong guess</p>
      <p>Game ends at 11 points!</p>

      <h2>Game Rules: Advanced</h2>
      <p><b>First, select any two video cards.</b><br />Each video card is composed of six elements.<br />Each card shares one element with every other card in its deck (and only one).</p>
      <p><b>Second, pick a prompt.</b><br />These prompts were given to an AI to render. View the cards from the lens of the AI.<br />Notice the uncanny valley separating the real world from the vision of an AI.</p>
      <p><i>In the <b>advanced game</b>, every card has one sibling in which all elements match.<br />Avoid picking a prompt for siblings!</i></p>
      <p>+2 points for a correct guess<br />−1 point for a wrong guess</p>
      <p>Game ends at 11 points!</p>
    </div>
  );
}
